import 'polyfills';

import ReactOnRails from 'react-on-rails';

import DesignAndInspireWidgetIndex from "../../components/Widgets/Roofing/DesignAndInspireWidgetCore/Index";

ReactOnRails.register({
  'Widgets::Roofing::Designandinspirewidgetcore::Index': DesignAndInspireWidgetIndex,
});
